import { Group } from '@kalos/kalos-rpc';
import { useQuery } from '@tanstack/react-query';

import { GroupClientService } from '../../tools/helpers';
import { queryKeys } from './constants';
import { type EntityFilter } from './utils';

export type GroupFilter = EntityFilter<Group>;
export const useGroupsQuery = ({
  filter = {},
  enabled = true,
}: { filter?: GroupFilter; enabled?: boolean } = {}) => {
  return useQuery({
    queryFn: () => {
      const req = Group.create(filter);
      return GroupClientService.BatchGet(req);
    },
    queryKey: [queryKeys.group.root, queryKeys.group.list, queryKeys.group.getHash(filter)],
    enabled,
  });
};
